import { createAction } from '@reduxjs/toolkit';

export const changePageState = createAction<number>('IMPORT/CHANGE_STATE');

export const changeConnectionType = createAction<'livestream' | 'lookback'>('IMPORT/CHANGE_TYPE');

export const changeStartDate = createAction<string>('IMPORT/CHANGE_START_DATE');

export const changeEndDate = createAction<string>('IMPORT/END_START_DATE');

export const changeLengthOfWork = createAction<string>('IMPORT/CHANGE_LENGTH_OF_WORK');

export const changePlatforms = createAction<string[]>('IMPORT/CHANGE_PLATFORMS');

export const changeScanFor = createAction<string>('IMPORT/CHANGE_SCAN_FOR');

export const changeUsersListFileName = createAction<string>('IMPORT/CHANGE_USERS_LIST_FILE_NAME');

export const cleanImportState = createAction('IMPORT/CLEAN_STATE');
